import * as React from 'react';
import {useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import { Divider } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from "@mui/icons-material/Close"; // Import Close Icon
import { useState,useMemo  } from "react";
import {  Menu, MenuItem, Avatar,Badge,Breadcrumbs,Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom"; // Import for navigation
import ShoppingBagOutlinedIcon  from "@mui/icons-material/ShoppingBagOutlined";
import DashboardIcon from "@mui/icons-material/SpaceDashboard"; 
import SettingsIcon from "@mui/icons-material/Tune";
import LogoutIcon from "@mui/icons-material/Logout";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import logo from "../../images/logo.png"
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ShopingContext from '../context/ShopingContext';
import Cart from '../../Cart';
import {
  PersonOutline as PersonOutlineIcon,
  SettingsOutlined as SettingsOutlinedIcon,
  HomeOutlined as HomeOutlinedIcon,
  LogoutOutlined as LogoutOutlinedIcon
} from '@mui/icons-material';
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': {
            ...openedMixin(theme),
          
            boxShadow: '4px 0 15px rgba(0,0,0,0.1)',
          },
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        },
      },
    ],
  }),
);

export default function Dashboard({children}) {
  const [open, setOpen] = React.useState(true);
  const [openCart, setOpenCart] = useState(false); // Manage popup state
  const { cartItems  } = useContext(ShopingContext); // ✅ Access products from context
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [mode, setMode] = useState("light");
const [anchorEl, setAnchorEl] = useState(null);
 // Apply theme based on mode
 const theme = useMemo(() =>
    createTheme({
      palette: {
        mode: mode,
      },
    }), [mode]
  );
  const toggleDarkMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };
  
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const navigate = useNavigate(); // Hook for redirection
  const [user, setUser] = useState(null);
  useEffect(() => {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(sessionUser);
  }, []);
  const handleLogout = () => {
    sessionStorage.removeItem("user");
    setUser(null);
    navigate("/");
  
  };
  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };
  const menuItems = [
    { text: "Dashboard", path: "/dashboard", icon: <DashboardIcon /> },
    { text: "Profile", path: "/dashboard", icon: <RequestQuoteIcon /> },
    { text: "Earnings", path: "/earnings", icon: <SettingsIcon /> },
    { text: "Transactions", path: "/transactions", icon: <RequestQuoteIcon /> },
    { text: "Shop", path: "/vendor-shop", icon: <ShoppingBagIcon /> },
   
  ];
  const settingsItems = [
   
    { text: "Logout", onClick: handleLogout, icon: <LogoutIcon /> },
  ];
  

  return (
    <Box sx={{ display: 'flex',backgroundColor:"#f3f3f9",boxShadow:"0" }}>
        <ThemeProvider theme={theme}>
        <CssBaseline />
    
      <AppBar position="fixed" open={open} sx={{backgroundColor:"#fff",boxShadow:"0"}}>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between",borderBottom:"1px solid #e9ebec" }}>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={[{ marginRight: 5,color:"#000",border:"1px solid #f5f5f5" }, open && { display: "none" }]}
      >
        <MenuIcon />
      </IconButton>


     <Box 
  sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: 1.2,
    '&:hover': { 
      cursor: 'pointer',
      transform: 'scale(1.02)',
      transition: 'transform 0.3s ease'
    }
  }}
>
  {/* Logo with subtle shadow */}
  <img 
    src={logo}
    alt="Magnessa Logo" 
    style={{ 
      height: 58, 
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' 
    }}
  />

  {/* Text container with vertical alignment */}
  <Box sx={{ 
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.3,
    gap: 0.3
  }}>
    <Typography 
      variant="h7" 
      sx={{ 
        fontWeight: 700,
        color: 'text.primary',
        letterSpacing: 0.5,
        mt:1.5
      }}
    >
      Elite Magnessa
    </Typography>
    
    <Typography 
      variant="subtitle1"
      sx={{ 
        color: 'text.secondary',
        fontSize: '0.85rem',
        fontWeight: 500,
        letterSpacing: 0.25
      }}
    >
      Vendor Management
    </Typography>
  </Box>
</Box>
    </Box>


 
    {/* Right Section */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>



      {/* Cart Icon */}
      <IconButton
         onClick={() => setOpenCart(true)}// Add navigation to cart page
        sx={{
          color: "#fff",
          width: 35,
          height: 35,
          borderRadius: "50%",
          "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" },
        }}
      >
        <Badge badgeContent={cartItems.length} color="error">
          <ShoppingBagOutlinedIcon sx={{ color: "#2A3B5A" }} />
        </Badge>
      </IconButton>

      {/* Cart Popup */}
      <Dialog open={openCart} onClose={() => setOpenCart(false)} maxWidth="md" fullWidth>
        <DialogTitle>
        <Box display="flex" justifyContent="flex-end">
    <IconButton onClick={() => setOpenCart(false)} sx={{ color: "gray" }}>
      <CloseIcon />
    </IconButton>
  </Box>
          </DialogTitle>
        <DialogContent>
          <Cart isPopup={true} />
        </DialogContent>
      </Dialog>
              
      {/* Light/Dark Mode Toggle */}
      <IconButton onClick={toggleDarkMode} color="inherit" sx={{color:"#299cdb"}}>
        {mode === "light" ? <Brightness4 /> : <Brightness7 />}
      </IconButton>

      {/* User Profile with Dropdown */}
<Box
  sx={{ 
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "8px 16px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    '&:hover': {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      boxShadow: 1
    }
  }}
  onClick={handleProfileMenuOpen}
>
  <Avatar 
    src= {user?.AcntLst?.[0]?.Image} 
    sx={{ 
      width: 40, 
      height: 40,
      border: "2px solid #fff",
      boxShadow: (theme) => theme.shadows[2]
    }}
  />
{user ? (
      <>
  <Box sx={{ ml: 2 }}>
    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "text.primary" }}>
    {user?.AcntLst?.[0]?.FirstName + " " + user?.AcntLst?.[0]?.LastName || "Guest"}
    </Typography>
    <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1 }}>
      Premium Account
    </Typography>
  </Box>
  </>
    ) : (
      <>
      No user
      </>
      )}
</Box>

{/* Dropdown Menu */}
<Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleProfileMenuClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
  sx={{
    mt: 1,
    '& .MuiPaper-root': {
      width: 200,
      borderRadius: "8px",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
      border: "1px solid rgba(0, 0, 0, 0.05)"
    },
    '& .MuiList-root': {
      padding: "8px 0"
    }
  }}
>
  <MenuItem onClick={handleProfileMenuClose} sx={{ py: 1.5 }}>
    <PersonOutlineIcon sx={{ mr: 2, color: "text.secondary" }} />
    Profile
  </MenuItem>
  <MenuItem onClick={handleProfileMenuClose} sx={{ py: 1.5 }}>
    <SettingsOutlinedIcon sx={{ mr: 2, color: "text.secondary" }} />
    Settings
  </MenuItem>
  <Divider sx={{ my: 1 }} />
  <MenuItem onClick={() => navigate("/")} sx={{ py: 1.5 }}>
    <HomeOutlinedIcon sx={{ mr: 2, color: "text.secondary" }} />
    Back to Home
  </MenuItem>
  <Divider sx={{ my: 1 }} />
  <MenuItem 
    onClick={handleLogout} 
    sx={{ 
      py: 1.5,
      color: "error.main",
      '&:hover': { backgroundColor: "error.lighter" }
    }}
  >
    <LogoutOutlinedIcon sx={{ mr: 2 }} />
    Logout
  </MenuItem>
</Menu>


    </Box>

    
  </Toolbar>

<Toolbar sx={{ mt: 0, px: 0, display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#f8f9fa", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }} style={{minHeight:"40px"}}>
  {/* Left - Breadcrumb */}
  <Breadcrumbs aria-label="breadcrumb">
    <Typography color="text.primary" sx={{fontSize:"12px"}}>Home</Typography>
    <Typography color="text.secondary" sx={{fontSize:"12px"}}>Dashboard</Typography>
  </Breadcrumbs>

  {/* Right - Full Date */}
  <Typography variant="body1" color="text.secondary" sx={{fontSize:"12px"}}>
    {new Date().toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    })}
  </Typography>
</Toolbar>
</AppBar>;

<Drawer variant="permanent" open={open} sx={{
    "& .MuiDrawer-paper": {
      bgcolor: "#2FA8EF", // Background color for drawer paper
      color: "white", // Text color for better contrast
      fontSize:"14px",
      boxShadow:"0"
    },
  }}
>
        <DrawerHeader sx={{backgroundColor:"#2FA8EF"}}>
          <IconButton onClick={handleDrawerClose} sx={{color:"#fff"}}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
       
        <List sx={{ backgroundColor: "#2FA8EF" }}>
  {menuItems.map(({ text, path, icon }) => (
    <ListItem key={text} disablePadding sx={{ display: "block" }}>
      <ListItemButton
        sx={{ minHeight: 48, px: 3,my:1 }}
        onClick={() => navigate(path)} // Navigate to the respective route
      >
        <ListItemIcon sx={{ minWidth: 0, justifyContent: "center", color: "#fff",
           "& svg": { fontSize: "12px" },
         }}>
          {icon}
        </ListItemIcon>
        <ListItemText primary={text} sx={{ opacity: open ? 1 : 0, color: "#fff",ml:2 }} />
      </ListItemButton>
    </ListItem>
  ))}


{settingsItems.map(({ text, onClick, icon }) => (
  <ListItem key={text} disablePadding sx={{ display: "block" }}>
    <ListItemButton
      sx={{ minHeight: 48, px: 3 }}
      onClick={onClick}  // Now using onClick directly
    >
      <ListItemIcon sx={{ minWidth: 0, justifyContent: "center", color: "#fff" }}>
        {icon}
      </ListItemIcon>
      <ListItemText primary={text} sx={{ opacity: open ? 1 : 0, color: "#fff", ml: 2 }} />
    </ListItemButton>
  </ListItem>
))}
</List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3,mt:8,backgroundColor:"#f3f3f9",minHeight:"100vh"}}>
        <DrawerHeader />

        {children}

      </Box>
      </ThemeProvider>
    </Box>

  );
}
